export const GAUGE_CONFIG = {
  size: 300,
  strokeWidth: 36,
  startAngle: -Math.PI / 2,
  endAngle: Math.PI / 2,
  padAngle: 0.005,
  emptyArcColorKey: 'Hairline/Light/Primary',
} as const;

export const LEGEND_CONFIG = {
  bulletSize: 8,
  rowGap: 8,
} as const;
